import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * Hook to get student certificates
 */
export const useGetStudentCertificates = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [certificates, setCertificates] = useState([]);

  const { axiosInstance } = useAxios();

  const getStudentCertificates = async ({ studentId, questId }) => {
    const sId = Number(studentId);
    const qId = Number(questId);

    if (!Number.isInteger(sId) || !Number.isInteger(qId)) {
      setError("studentId and questId are required and must be integers");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const response = await axiosInstance.get(
        `${TENANT_DOMAIN}/student/certificates/${sId}/${qId}`
      );

      setCertificates(response?.data.data || []);
      return response?.data;
    } catch (err) {
      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { getStudentCertificates, certificates, loading, error };
};
